module.exports = __webpack_public_path__ + "static/media/automation.471b2f27.svg";